<template>
  <div style="width:100%">
    <div style="padding:20px;width: 100%;box-sizing: border-box">
      <p>问题详情</p>
      <div style="width: 100%;text-align: right">
        <el-button type="primary" size="small" :loading="saving" @click="updateExerciseQuestion">提交</el-button>
      </div>
      <div class="item" style="display: flex">
        <div>
          <span>显示序号</span>
          <el-input-number style="margin-left: 10px" v-model="editForm.extra_index"></el-input-number>
        </div>
        <div class="item" style="margin-left: 20px">
          <span>主题</span>
          <el-input type="text" v-model="editForm.question_subject"></el-input>
        </div>
      </div>
      <div style="display: flex;flex-direction: row;margin-top: 10px;width: 100%">
        <div class="item">
          <span>年份</span>
          <el-input type="text" v-model="editForm.question_year"></el-input>
        </div>
        <div class="item">
          <span>等级</span>
          <el-input type="text" v-model="editForm.question_level"></el-input>
        </div>
        <div class="item">
          <span>考点</span>
          <el-input type="text" style="width: 400px" v-model="editForm.question_competency"></el-input>
        </div>
        <div class="item">
          <span>分值</span>
          <el-input type="number" v-model="editForm.question_marks"></el-input>
        </div>
      </div>
      <div style="display: flex;flex-direction: row;margin-top: 10px;width: 100%">
        <div class="item">
          <span>组</span>
          <el-input type="text" v-model="editForm.question_group" placeholder="同一组题目用于考试时打乱题序"></el-input>
        </div>
        <div class="item">
          <span>对应材料</span>
          <el-select
            v-model="editForm.question_article"
            filterable
            clearable
            placeholder="选择材料（如 M1），可留空"
            style="width: 400px; margin-left: 10px"
          >
            <el-option
              v-for="item in articleOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div style="margin-top: 10px;display: flex">
        <div class="item" style="width: 100%">
          <p>题目</p>
          <Tinymce v-if="formReady" key="question-info-main-editor" id="question-info-main-editor" v-model="editForm.question_question" :height="80" style="margin-top: 15px"></Tinymce>
        </div>
      </div>

      <template v-if="formReady && editForm.question_type === 'select'">
        <div
          v-for="option in optionLetters"
          :key="'option-' + option"
          class="option-version-block"
        >
          <p>选项{{ option }}</p>
          <div class="option-version-row">
            <div class="item option-version-item">
              <p>Version A</p>
              <Tinymce
                :key="'question-info-option-' + option.toLowerCase() + '-editor'"
                :id="'question-info-option-' + option.toLowerCase() + '-editor'"
                v-model="editForm['question_option' + option]"
                :height="80"
                style="margin-top: 15px"
              ></Tinymce>
            </div>
            <div class="item option-version-item">
              <p>Version B</p>
              <Tinymce
                :key="'question-info-option-' + option.toLowerCase() + '-version-b-editor'"
                :id="'question-info-option-' + option.toLowerCase() + '-version-b-editor'"
                v-model="editForm['question_option' + option + '_versionB']"
                :height="80"
                style="margin-top: 15px"
              ></Tinymce>
            </div>
          </div>
        </div>
        <div class="item" style="margin-top: 10px">
          <span>答案</span>
          <el-select v-model="editForm.question_answer" style="margin-left:10px">
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
            <el-option label="D" value="D"></el-option>
            <el-option label="E" value="E"></el-option>
          </el-select>
        </div>
      </template>

      <div class="item" style="margin-top: 10px">
        <span>题目类型</span>
        <el-select v-model="editForm.question_type" style="margin-left:10px">
          <el-option label="选择题" value="select"></el-option>
          <el-option label="问答题" value="input"></el-option>
        </el-select>
      </div>

      <div v-if="formReady && editForm.question_type === 'input'" class="essay-config">
        <div class="item" style="margin-top: 10px">
          <span>最大单词数</span>
          <el-input
              type="number"
              min="1"
              v-model="editForm.question_input_restrict"
          ></el-input>
        </div>
        <div class="item" style="margin-top: 18px">
          <p>参考答案</p>
          <Tinymce key="question-info-reference-answer-editor" id="question-info-reference-answer-editor" v-model="editForm.question_reference_answer" :height="180"></Tinymce>
        </div>
        <div class="item" style="margin-top: 18px">
          <p>AI 评分标准</p>
          <Tinymce key="question-info-scoring-rubric-editor" id="question-info-scoring-rubric-editor" v-model="editForm.question_scoring_rubric" :height="220"></Tinymce>
        </div>
        <el-alert
            title="问答题交卷后进入异步 AI 评分；参考答案或评分标准至少填写一项。"
            type="info"
            :closable="false">
        </el-alert>
      </div>

    </div>
  </div>
</template>

<script>
import { getExerciseQuestion, updateExerciseQuestion, getExerciseTemplate } from '../api/examAdmin'
import Tinymce from '../components/Tinymce'
import { buildHtmlMaterialOptions } from '../utils/htmlMaterials'

export default {
  components: {
    Tinymce
  },
  data () {
    return {
      question_id: '',
      template_id: '',
      formReady: false,
      saving: false,
      optionLetters: ['A', 'B', 'C', 'D', 'E'],
      articleOptions: [],
      achieve_options: [
        {
          label: 'A',
          value: '甲'
        },
        {
          label: 'B',
          value: '乙'
        }
      ],
      editForm: {
        _id: {
          $id: ''
        },
        question_subject: '',
        question_year: '',
        question_level: '',
        question_competency: '',
        question_question: '',
        question_optionA: '',
        question_optionB: '',
        question_optionC: '',
        question_optionD: '',
        question_optionE: '',
        question_optionA_versionB: '',
        question_optionB_versionB: '',
        question_optionC_versionB: '',
        question_optionD_versionB: '',
        question_optionE_versionB: '',
        question_answer: '',
        achieve_arr: [],
        extra_index: 0,
        question_marks: 0,
        question_type: 'select',
        question_input_restrict: 200,
        question_reference_answer: '',
        question_scoring_rubric: '',
        question_group: '',
        question_article: ''
      }
    }
  },
  mounted () {
    this.question_id = this.$route.query.question_id || ''
    this.template_id = this.$route.query.template_id || ''
    this.loadArticleOptions()
    if (this.question_id !== '') {
      this.fetchData()
    } else {
      this.formReady = true
    }
  },
  methods: {
    loadArticleOptions () {
      if (!this.template_id) {
        this.articleOptions = []
        return
      }
      getExerciseTemplate(this.template_id).then(res => {
        if (res.data.code !== 0) {
          return
        }
        const materials = (res.data.data && res.data.data.html_materials) || []
        this.articleOptions = buildHtmlMaterialOptions(materials)
        this.ensureCurrentArticleOption()
      }).catch(() => {
        this.articleOptions = []
      })
    },
    ensureCurrentArticleOption () {
      const current = this.editForm.question_article
      if (current && this.articleOptions.indexOf(current) === -1) {
        this.articleOptions = [current].concat(this.articleOptions)
      }
    },
    fetchData () {
      getExerciseQuestion(this.question_id).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          this.editForm = Object.assign({}, this.editForm, res.data.data)
          if (!['select', 'input'].includes(this.editForm.question_type)) {
            this.editForm.question_type = 'select'
          }
          this.ensureCurrentArticleOption()
          this.formReady = true
        }
      })
    },
    async updateExerciseQuestion () {
      if (this.saving) {
        return
      }

      if (this.editForm.question_type === 'select') {
        if (!this.editForm.question_answer) {
          this.$message.error('请选择答案')

          return
        }
      } else {
        const limit = parseInt(this.editForm.question_input_restrict, 10)
        if (!limit || limit < 1) {
          this.$message.error('请输入有效的最大单词数')
          return
        }
        if (!this.hasText(this.editForm.question_reference_answer) && !this.hasText(this.editForm.question_scoring_rubric)) {
          this.$message.error('参考答案或 AI 评分标准至少填写一项')
          return
        }
      }

      const isCreating = !this.question_id
      this.saving = true

      try {
        const res = await updateExerciseQuestion(this.question_id,
          this.editForm.question_subject,
          this.editForm.question_year,
          this.editForm.question_level,
          this.editForm.question_competency,
          this.editForm.question_question,
          this.editForm.question_optionA,
          this.editForm.question_optionB,
          this.editForm.question_optionC,
          this.editForm.question_optionD,
          this.editForm.question_optionE,
          this.editForm.question_answer,
          this.editForm.extra_index,
          this.editForm.achieve_arr,
          this.editForm.question_marks,
          this.editForm.question_type,
          this.editForm.question_input_restrict,
          this.editForm.question_reference_answer,
          this.editForm.question_scoring_rubric,
          this.editForm.question_group,
          this.editForm.question_article,
          this.editForm.question_optionA_versionB,
          this.editForm.question_optionB_versionB,
          this.editForm.question_optionC_versionB,
          this.editForm.question_optionD_versionB,
          this.editForm.question_optionE_versionB
        )

        if (res.data.code === 0) {
          if (isCreating) {
            const savedId = this.getSavedQuestionId(res.data.data)
            if (!savedId) {
              this.$message.error('题目已保存，但服务器未返回题目 ID，请刷新后重试')
              return
            }
            this.question_id = savedId
            this.$router.replace({
              path: '/questionInfo',
              query: {
                question_id: savedId,
                ...(this.template_id ? { template_id: this.template_id } : {})
              }
            }).catch(() => {})
          }
          this.$message({
            message: isCreating ? '创建成功' : '更新成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.data.msg || '保存失败，请稍后重试')
        }
      } catch (error) {
        this.$message.error('保存失败，请检查网络后重试')
      } finally {
        this.saving = false
      }
    },
    getSavedQuestionId (question) {
      if (!question || !question._id) {
        return ''
      }
      if (typeof question._id === 'string') {
        return question._id
      }
      return question._id.$id || question._id.$oid || ''
    },
    hasText (html) {
      const node = document.createElement('div')
      node.innerHTML = html || ''
      return (node.textContent || node.innerText || '').trim().length > 0
    }
  }

}
</script>

<style scoped>
.item {
  margin-right: 20px;
  /*margin-top:20px*/
}

.item .el-input {
  width: 80%;
  margin-left: 10px;
}

.option-version-block {
  margin-top: 10px;
}

.option-version-row {
  display: flex;
}

.option-version-item {
  flex: 1;
  min-width: 0;
}
</style>
